module.exports = __webpack_public_path__ + "img/toplogo3.37889930.png";